export default "__VITE_ASSET__ac39eee4__"